var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationDu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12147_10318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 2.66406C10.8393 2.66406 6.66602 6.8374 6.66602 11.9974C6.66602 18.9974 15.9993 29.3307 15.9993 29.3307C15.9993 29.3307 25.3327 18.9974 25.3327 11.9974C25.3327 6.8374 21.1593 2.66406 15.9993 2.66406ZM15.9993 15.3307C14.1593 15.3307 12.666 13.8374 12.666 11.9974C12.666 10.1574 14.1593 8.66406 15.9993 8.66406C17.8393 8.66406 19.3327 10.1574 19.3327 11.9974C19.3327 13.8374 17.8393 15.3307 15.9993 15.3307Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12147_10318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDu);
export default __webpack_public_path__ + "static/media/LocationDU.5892996b.svg";
export { ForwardRef as ReactComponent };